function animateIn() {
  $('.js-or-animateIn').each(function(){
    var $this = $(this);
    var position = $this.offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > position - windowHeight + 0){
      setTimeout(function(){
        $this.addClass('-show');
      },400);   
    }
  });
}
function tab() {
   $('.js-or-tabButtonTrigger').click(function (){
      var $this = $(this);
      var currentID = $this.attr('data-name');
      $('.js-or-tabButtonTrigger').each(function(){
        if ($(this).attr('data-name') == currentID) {
          $(this).attr('data-current', 'true');
        } else {
          $(this).attr('data-current', 'false');
        }
      });
      $('.js-or-tabBodyItem').each(function(){
        if ($(this).attr('data-name') == currentID) {
          $(this).attr('data-current', 'true');
        } else {
          $(this).attr('data-current', 'false');
        }
      });
    });
}


/**
 * @description homeSlider
 */
const homeSlider = () => {
  const homeSliderFunc = (el) => {
    const swiper = new Swiper(el, {
        effect: 'fade',
        speed: 1000,
        autoplay: {
          delay: 5000,
        },
        direction: 'horizontal',
        loop: true,
    });
  }
  const sliders = document.querySelectorAll('.homeSlider__container')
  if (!sliders.length) {
    return
  }
  sliders.forEach(function (slider) {
    homeSliderFunc(slider)
  })
}
$(function(){
    homeSlider()
    animateIn()
    tab()
    $(window).scroll(function (){
      animateIn()
    });
});